export default "__VITE_ASSET__DQD$b5fA__"